// services/favorite.js
import api from './api';

const favoriteService = {
  /**
   * Récupérer les favoris d'un utilisateur
   */
  getFavorites: async (userId) => {
    try {
      const response = await api.get('/get-favorites.php', {
        params: { user_id: userId }
      });
      return response.data;
    } catch (error) {
      console.error('❌ getFavorites error:', error);
      return { success: false, favorites: [] };
    }
  },

  /**
   * Ajouter un favori
   */
  addFavorite: async (userId, favoriId) => {
    try {
      const response = await api.post('/add-favorite.php', {
        user_id: userId,
        favori_id: favoriId
      });
      return response.data;
    } catch (error) {
      console.error('❌ addFavorite error:', error);
      return { success: false };
    }
  },

  /**
   * Supprimer un favori
   */
  removeFavorite: async (userId, favoriId) => {
    try {
      const response = await api.post('/remove-favorite.php', {
        user_id: userId,
        favori_id: favoriId
      });
      return response.data;
    } catch (error) {
      console.error('❌ removeFavorite error:', error);
      return { success: false };
    }
  },

  /**
   * Vérifier si un utilisateur est en favori
   */
  isFavorite: async (userId, favoriId) => {
    try {
      const response = await api.get('/check-favorite.php', {
        params: { 
          user_id: userId,
          favori_id: favoriId
        }
      });
      return response.data.isFavorite || false;
    } catch (error) {
      console.error('❌ isFavorite error:', error);
      return false;
    }
  }
};

export default favoriteService;